import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageSettingsAiComponent } from './page.settings.ai/page.settings.ai.component';
import { PageAnalysisDetailComponent } from './page.analysis.detail/page.analysis.detail.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageRequestLinkComponent } from './page.request.link/page.request.link.component';
import { PageCrawlDetailComponent } from './page.crawl.detail/page.crawl.detail.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageScrapComponent } from './page.scrap/page.scrap.component';
import { PagePresentationComponent } from './page.presentation/page.presentation.component';
import { PageProposalComponent } from './page.proposal/page.proposal.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageProposalDetailComponent } from './page.proposal.detail/page.proposal.detail.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageCodexComponent } from './page.codex/page.codex.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageAssetsComponent } from './page.assets/page.assets.component';
import { LayoutMainComponent } from './layout.main/layout.main.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageCrawlComponent } from './page.crawl/page.crawl.component';
import { PageAnalysisComponent } from './page.analysis/page.analysis.component';
import { PagePresentationDetailComponent } from './page.presentation.detail/page.presentation.detail.component';
import { PageCodexDetailComponent } from './page.codex.detail/page.codex.detail.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageSettingsAiComponent,
        PageAnalysisDetailComponent,
        PortalSeasonTreeComponent,
        PageRequestLinkComponent,
        PageCrawlDetailComponent,
        ComponentNavSidebarComponent,
        PageScrapComponent,
        PagePresentationComponent,
        PageProposalComponent,
        PortalSeasonPaginationComponent,
        PortalPostDetailComponent,
        PageProposalDetailComponent,
        PageDashboardComponent,
        LayoutEmptyComponent,
        PortalSeasonModalComponent,
        PortalSeasonLoadingDefaultComponent,
        PageCodexComponent,
        PortalSeasonFormDropdownComponent,
        PortalPostListComponent,
        PageAccessComponent,
        PageAssetsComponent,
        LayoutMainComponent,
        PortalSeasonLoadingSeasonComponent,
        PageCrawlComponent,
        PageAnalysisComponent,
        PagePresentationDetailComponent,
        PageCodexDetailComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }